// extracted by mini-css-extract-plugin
module.exports = {"videoPageCtaButton":"VideoActionButtons_videoPageCtaButton__hz99Q","placeholder":"VideoActionButtons_placeholder__rSnmy"};